import { FC, SVGProps } from 'react'

export const InputArrowUp: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
    <path
      d="M5.93137 10H10.0686C10.6744 10 10.9774 10 11.1176 9.8802C11.2393 9.77626 11.3039 9.62033 11.2914 9.46077C11.2769 9.27688 11.0627 9.06269 10.6343 8.63432L8.56569 6.56569C8.36768 6.36768 8.26867 6.26867 8.15451 6.23158C8.05409 6.19895 7.94591 6.19895 7.84549 6.23158C7.73133 6.26867 7.63232 6.36768 7.43432 6.56568L7.43431 6.56569L5.36569 8.63431C4.93731 9.06269 4.72312 9.27688 4.70865 9.46077C4.69609 9.62033 4.76068 9.77626 4.88238 9.8802C5.02265 10 5.32555 10 5.93137 10Z"
      fill="#1B1B1B"
    />
  </svg>
)
